import { useEffect, useState } from "react"
import { useLocation, useParams, useSearchParams } from "react-router-dom";

export default function Auth() {

  const location = useLocation()
  let { type } = useParams()
  let [searchParams, setSearchParams] = useSearchParams();

  const [code, setCode] = useState('')

  useEffect(() => {
    console.log(location)
  }, [location])

  useEffect(() => {

    if(!type) return

    const code = searchParams.get('code')

    if(code !== null) {
      
      setCode(code)
      setSearchParams({})
      if(!type.includes('-stage')) {
        window.location.replace(`squidshell://login?code=${code}&type=${type}`)
      }
      else {
        window.location.replace(`squidshell-dev://login?code=${code}&type=${type.split('-')[0]}`)
      }
    }
  }, [searchParams, type])

  return (
    <>
    <header>
      <div className="inner">
        <img src="/images/logo.png" alt="squidshell" />
        <h1>Squid Shell</h1>
      </div>
    </header>

    <main>
      <div className="inner">
        <div className="card">
          <div>
            <h3>Redirecting to</h3>
            <h2>Squid Shell ...</h2>
          </div>

          <div>
            <p>You will be redirectred in a few moments.</p>
            <p>if the app doesn't open, click Relaunch below.</p>
          </div>
          <button
            onClick={e => {

              if(!type) return

              console.log(type, code)

              if(!type.includes('-stage')) {
                window.location.replace(`squidshell://login?code=${code}&type=${type}`)
              }
              else {
                window.location.replace(`squidshell-dev://login?code=${code}&type=${type.split('-')[0]}`)
              }
            }}
          >Relaunch</button>
        </div>
      </div>
    </main>
    </>
  )
}